import {ExceedScoreStatus, PassScoreStatus, ScoreStatus, WarnScoreStatus} from "../CalculatePasswordScore";
import passwordStatus_Exceed from "../../../assets/images/img_status_exceed.png"
import passwordStatus_Pass from "../../../assets/images/img_status_pass.png"
import passwordStatus_Warn from "../../../assets/images/img_status_warn.png"
import passwordStatus_Fail from "../../../assets/images/img_status_fail.png"
import {Image} from "react-bootstrap";
import * as React from "react";

export interface PasswordCheckStatusImageProps {status: ScoreStatus};
export default function PasswordCheckStatusImage(props: PasswordCheckStatusImageProps){
    switch(props.status){
        case PassScoreStatus:{
            return <Image src={passwordStatus_Pass} />
        }
        case ExceedScoreStatus:{
            return <Image src={passwordStatus_Exceed} />
        }
        case WarnScoreStatus:{
            return <Image src={passwordStatus_Warn} />
        }
        default: {
            return <Image src={passwordStatus_Fail} />
        }
    }
}
